import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SupportContextService } from "../shared/services/support-context.service";

@Component({
    selector: "app-user-profile",
    templateUrl: "./user-profile.component.html",
    standalone: false
})
export class UserProfileComponent implements OnInit {
  
  constructor(
    public readonly supportContext: SupportContextService,
    private readonly router: Router
  ) { }

  ngOnInit() { }

  returnToSupportPage(): void {
    this.router.navigate(['/support-manage-users']);
  }
}
